import { render, staticRenderFns } from "./EthnicityManagementEdit.vue?vue&type=template&id=375e8519&scoped=true&"
import script from "./EthnicityManagementEdit.vue?vue&type=script&lang=js&"
export * from "./EthnicityManagementEdit.vue?vue&type=script&lang=js&"
import style0 from "./EthnicityManagementEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EthnicityManagementEdit.vue?vue&type=style&index=1&id=375e8519&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375e8519",
  null
  
)

export default component.exports